import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/logo3.webp"; 
import "../styles/PrivacyPolicy.css"; // Reuse the same CSS file for consistency

const TermsConditions = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="policy-page-wrapper">
      {/* Header Section */}
      <header className="contact-header over-banner">
        <div className="contact-logo">
          <img src={logo} alt="TravelKariye Logo" />
        </div>
        <nav className="contact-nav">
          <Link to="/" className={location.pathname === '/' ? 'active-link' : ''}>Home</Link>
          <Link to="/packages">Packages</Link>
          <div className="contact-dropdown">
            <span className={`contact-dropbtn ${['/goa', '/abu', '/dubai'].includes(location.pathname) ? 'active-link' : ''}`}>
              Destinations
            </span>
            <div className="contact-dropdown-content">
              <Link to="/goa">Goa</Link>
              <Link to="/kerala">Kerala</Link>
              <Link to="/rajasthan">Rajasthan</Link>
              <Link to="/himachal">Himachal Pradesh</Link>
              <Link to="/uttarakhand">Uttarakhand</Link>
              <Link to="/abu">Abu Dhabi</Link>
              <Link to="/dubai">Dubai</Link>
            </div>
          </div>
          <Link to="/hotels">Hotels</Link>
          <Link to="/contact-us" className={location.pathname === '/contact-us' ? 'active-link' : ''}>Contact Us</Link>
        </nav>
        <Link to="/booknow">
          <button className="contact-book-btn">Book Now</button>
        </Link>
      </header>

      {/* Hero Section */}
      <div className="policy-hero-spacer">
        <div className="policy-header-text">
          <span className="subtitle">Our Agreement</span>
          <h1>Terms & Conditions</h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="policy-container">
        <div className="policy-card">
          <section>
            <h3>1. Acceptance of Terms</h3>
            <p>
              By accessing and using TravelKariye.com, you agree to be bound by these Terms and Conditions. 
              Our services are provided to assist customers in gathering travel information and 
              determining the availability of travel-related goods and services.
            </p>
          </section>

          <section>
            <h3>2. Booking & Payments</h3>
            <p>
              All bookings are subject to availability at the time of reservation. Full or partial 
              payment may be required to confirm your tour package. Prices are subject to 
              change based on seasonal demand and third-party provider rates (Hotels/Airlines).
            </p>
          </section>

          <section>
            <h3>3. Cancellation & Refund Policy</h3>
            <p>
              Cancellations made 30 days prior to the travel date are eligible for a full refund 
              minus administrative fees. Cancellations made within 15 days may incur a 50% 
              charge. No-shows or cancellations within 48 hours are non-refundable.
            </p>
          </section>

          <section>
            <h3>4. User Responsibilities</h3>
            <p>
              Travelers are responsible for ensuring they possess valid identification, visas, 
              and health insurance required for their specific destinations. TravelKariye 
              is not liable for any delays caused by missing travel documentation.
            </p>
          </section>

          <section>
            <h3>5. Limitation of Liability</h3>
            <p>
              While we strive for excellence, TravelKariye acts as an agent for service 
              providers (hotels, transport, guides). We are not responsible for any personal 
              injury, property damage, or delays caused by these independent suppliers.
            </p>
          </section>

          <div className="last-updated">
            <p>Last Revised: April 24, 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;